import { Link, useLocation } from "@/lib/router-compat";
import { ChevronRight } from "lucide-react";
import { areas } from "@/data/areas";

const serviceNames: Record<string, string> = {
  "pool-remodeling": "Pool Remodeling & Resurfacing",
  "pool-deck-remodeling": "Pool Deck Remodeling",
  "driveway-patio-pavers": "Driveway & Patio Pavers",
  "outdoor-enhancements": "Outdoor Enhancements",
};

export function SiteBreadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbs = [{ label: "Home", path: "/" }];

  let currentPath = "";

  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;
    let label =
      segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ");

    // Custom mappings
    if (segment === "services") {
      label = "Services";
    } else if (segment === "areas") {
      label = "Areas We Serve";
    } else if (segment === "blog") {
      label = "Blog";
    } else if (pathnames[index - 1] === "services" && serviceNames[segment]) {
      label = serviceNames[segment];
    } else if (pathnames[index - 1] === "areas") {
      const area = areas.find((a) => a.slug === segment);
      if (area) label = area.name;
    }

    breadcrumbs.push({
      label,
      path: currentPath,
    });
  });

  return (
    <div className="absolute top-24 left-0 right-0 z-20">
      <div className="container mx-auto px-4">
        <nav className="flex items-center text-sm font-medium text-white/70 space-x-2">
          {breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <div key={index} className="flex items-center space-x-2">
                {item.path && !isLast ? (
                  <Link
                    to={item.path}
                    className="hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-white">{item.label}</span>
                )}
                {!isLast && <ChevronRight className="w-4 h-4" />}
              </div>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
